import { InfoOutlined } from "@material-ui/icons";
import React from "react";
import { Link } from "react-router-dom";

import "./Condiciones.scss";

export const Condiciones = () => {

    return (
        <div className="condiciones text-start border rounded-2 ps-3 mb-4">
            <div className="info m-2 text-start mb-3"><h3>Saber más</h3></div>
            <div className="info m-2"><Link to="/info">Cómo funciona eGrade <InfoOutlined className="solunion-color-icon"/></Link></div>
            <div className="info m-2"><Link to="/what">Qué es el eGrade <InfoOutlined className="solunion-color-icon"/></Link></div>
            <div className="info m-2"><Link to="/cost">Tarifa consultas eGrade<InfoOutlined className="solunion-color-icon"/></Link></div>
            <div className="info m-2"><Link to="/when">Cuándo usar eGrade<InfoOutlined className="solunion-color-icon"/></Link></div>
        </div>
    )
}
